import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Card, CardBody } from 'reactstrap';
import { StatusContext } from '../../utility/context/StatusContext';
import { serverRequest } from '../../utility/helpers/Axios/serverRequest';
import { useAsync } from '../../utility/hooks/useAsync';
import axios from 'axios';

export const FormPayment = (props) => {
  const { finishOwnerShip } = props;
  const { form } = useSelector((state) => state);
  const [activeIndex, setActiveIndex] = useContext(StatusContext);
  const [redsysData, setRedsysData] = useState({ orderId: null, form: {} });
  console.log(redsysData.form);
  const handleClickPay = async () => {
    const form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', redsysData.form.url);
    form.setAttribute('target', '_blank');
    for (const [key, value] of Object.entries(redsysData.form.body)) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }
    console.log(form);
    console.log(form.innerHTML);
    document.body.appendChild(form);
    form.submit();
    // document.body.removeChild(form);
  };

  const loadRedsysData = async () =>
    await serverRequest('redsys', form.id, { extraUrl: 'sendOrder' });
  useAsync(
    loadRedsysData,
    (data) => {
      setRedsysData(data);
    },
    [activeIndex],
    activeIndex === 4,
  );

  return (
    <>
      <Card>
        <CardBody className="row">
          <div className="col-12" style={{ textAlign: 'center' }}>
            <Button color="primary" className="w-40 " onClick={handleClickPay}>
              Pagar {redsysData.totalAmount} €
            </Button>
          </div>
        </CardBody>
      </Card>
      <div className="col-6" style={{ textAlign: 'left' }}>
        <Button onClick={() => setActiveIndex(activeIndex - 1)} color="primary">
          Atras{' '}
          <FontAwesomeIcon
            style={{ marginLeft: '3px' }}
            icon={faArrowLeft}
            size={'1x'}
          />
        </Button>
      </div>
    </>
  );
};
